module.exports = __webpack_public_path__ + "img/customer-logo-4.12eb80d5.jpg";